module.exports = __webpack_public_path__ + "assets/fdc416d95e2d69f403a39179acbe6782.mp4";